// used for page-load and page-segment-load events
export const FF_ALLOWLIST_FOR_PERF_METRICS = [
	'confluence.ssr.page-statuses',
	'analytics-next-use-modern-context_jira',
	'confluence_ssr_enable_tesseract_stream_endpoint',
	'confluence_use_canary',
	'confluence_use_parcel',
	'confluence_frontend_use_modern_rendering_engine',
	'confluence_ssr_load_after_paint_loadables_as_paint',
	'ssr_end_of_page_recommendation',
	'confluence_ssr_enable_hydration',
	'confluence_react_streaming',
	'confluence_ssr_enable_hydration_home',
	'confluence_preload_forge_viewport_heights',
	'confluence_frontend_vc_observer_initialization',
	'confluence_frontend_preload_edit_and_analytics',
	'confluence_ssr_enable_hydration_space_overview',
	'confluence_frontend_remove_comments_placeholder',
	'enable_loadable_placeholder_for_legacy_macros',
	'confluence_frontend_remove_eop_initial_animation',
	'confluence_frontend_cache_pagetree_reference',
	'edition_awareness_standard_upsell_confluence_ab',
	'edition_awareness_standard_upsell_confluence_ab_fg',
	'confluence_frontend_content_body_container',
	'platform-ssr-table-resize',
	'confluence_ssr_permissions_error_handler',
	'edit-team-connection-from-confluence',
	'confluence_frontend_ssr_autohighlights',
	'cc_ignore_placeholder_legacy_profile_wrapper',
	'cc_shortcut_ssr_placeholder',
	'cc_fix_macro_blocklist',
	'cc_fix_title_emoji_padding',
	'cc_increase_prealod_macro_timeout',
	'cc_macro_preload_early_exit',
	'confluence_optimize_space_macro_preloading',
	'confluence_frontend_ssr_empty_footer_comments',
	'confluence_frontend_exclude_excerpt_macro_vc',
	'confluence_frontend_exclude_page_properties_vc',
	'confluence_frontend_abort_vc_inline_comment_scroll',
	'platform_editor_fix_image_size_diff_during_ssr',
	'confluence_skip_ssr_redirect_incorrect_slug',
	'platform_ssr_smartlinks_editor',
	'confluence_preload_smartlink_live_page',
	'content_early_connect_iframe_initialization',
	'content_early_connect_iframe_initialization_part_2',
	'confluence_always_preload_superbatch',
	'confluence_preload_pagetree_space_transition',
	'confluence_frontend_fix_smart_link_flickering',
	'confluence_frontend_cookie_banner_min_height',
	'platform_fix_block_card_img_icon_vc',
	'confluence_frontend_abort_vc_object_comment_scroll',
];

// In order to reduce BM event payload size, include a FF in the BM payload only if it's in the allow list.
// The following FFs will be included in all types of BM event.
export const ALLOWLIST_FFS_CUSTOM_EVENTS = [];
